import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import * as XLSX from 'xlsx';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBookOpen, FiLogOut, FiUploadCloud, FiArrowLeft } = FiIcons;

const Header = ({ onOpenImporter, onToggleProtocol, isProtocolActive }) => {
  const { signOut } = useAuth();
  const { currentProject, saveInventoryData } = useData();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsProcessing(true);
    try {
      let extractedDate = null;
      const dateMatch = file.name.match(/(\d{8})/); 
      if (dateMatch) {
        const rawDate = dateMatch[1];
        extractedDate = `${rawDate.substring(6, 8)}/${rawDate.substring(4, 6)}/${rawDate.substring(0, 4)}`;
      }

      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_json(worksheet);

      const importMeta = {
        filename: file.name,
        extracted_date: extractedDate,
        upload_timestamp: new Date().toISOString()
      };

      await saveInventoryData(rawData, importMeta);
      alert(`✅ Datos actualizados.\nFecha: ${extractedDate || 'Desconocida'}`);
      e.target.value = ''; 

    } catch (error) {
      console.error(error);
      alert('Error: ' + error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <header className="bg-white shadow-sm px-4 py-1 h-16 flex justify-between items-center sticky top-0 z-40 border-b-2 border-red-600">
      <div className="flex items-center gap-3">
        {isProtocolActive ? (
          <button 
            onClick={() => onToggleProtocol(false)}
            className="mr-1 p-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors"
          >
            <SafeIcon icon={FiArrowLeft} className="text-xl" />
          </button>
        ) : (
          <img 
            src="https://assets.brandbay.io/brands/1736547941865x394131539339247600/assets/OX3X76ITURRI_YourSafetyMatters.jpg" 
            alt="ITURRI" 
            className="h-12 w-auto object-contain"
          />
        )}
        
        <div className="flex flex-col justify-center">
          <h1 className="font-medium text-slate-800 leading-none text-xl tracking-tight">
            {isProtocolActive ? 'MANUAL' : 'mini'}<span className="text-red-600 font-bold">{isProtocolActive ? 'OPERATIVO' : 'GIV'}</span>
          </h1>
          {!isProtocolActive && (
            <div className="flex flex-col">
              <span className="text-sm text-slate-600 font-bold uppercase truncate max-w-[200px] leading-tight mt-0.5">
                {currentProject?.name || '...'}
              </span>
              {currentProject?.last_import_info?.extracted_date && (
                 <span className="text-[9px] font-medium text-red-600 bg-red-50 px-1.5 rounded w-fit mt-0.5">
                   📅 {currentProject.last_import_info.extracted_date}
                 </span>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        {/* BOTÓN MODO PROTOCOLO */}
        <button 
          onClick={() => onToggleProtocol(!isProtocolActive)}
          className={`w-9 h-9 flex items-center justify-center rounded-lg transition-all active:scale-95 border ${
            isProtocolActive 
              ? 'bg-red-600 text-white border-red-600 shadow-md shadow-red-200' 
              : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'
          }`}
          title="Manual Operativo"
        >
          <SafeIcon icon={FiBookOpen} className="text-lg" />
        </button>

        {!isProtocolActive && (
          <label className={`
              flex items-center justify-center w-9 h-9 rounded-lg 
              ${isProcessing ? 'bg-gray-100' : 'bg-red-50 text-red-600 hover:bg-red-100'}
              cursor-pointer transition-all active:scale-95 border border-red-100
            `} title="Actualizar Base de Datos">
              <input 
                type="file" 
                accept=".xlsx, .xls" 
                className="hidden" 
                onChange={handleFileUpload}
                disabled={isProcessing}
              />
              {isProcessing ? (
                <span className="animate-spin text-sm">⏳</span>
              ) : (
                <SafeIcon icon={FiUploadCloud} className="text-lg" />
              )}
          </label>
        )}

        <button 
          onClick={signOut}
          className="w-9 h-9 flex items-center justify-center bg-white text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all active:scale-95 border border-slate-200 hover:border-red-100"
          title="Cerrar Sesión"
        >
          <SafeIcon icon={FiLogOut} className="text-lg" />
        </button>
      </div>
    </header>
  );
};

export default Header;